const escapeHtml = function (value) {
  if (!value) {
    return '';
  }
  var result = value.replace(/(?:\r\n|\r|\n)/g, '<br />');
  return result;
};

export { escapeHtml };
